export const industriesOptions = [
  { label: "Information Technology", value: "Information Technology" },
  { label: "Healthcare", value: "Healthcare" },
  { label: "Finance", value: "Finance" },
  { label: "Education", value: "Education" },
  { label: "Manufacturing", value: "Manufacturing" },
  { label: "Retail", value: "Retail" },
  { label: "Telecommunications", value: "Telecommunications" },
  { label: "Transportation & Logistics", value: "Transportation & Logistics" },
  { label: "Real Estate", value: "Real Estate" },
  { label: "Energy", value: "Energy" },
  { label: "Media & Entertainment", value: "Media & Entertainment" },
  { label: "Agriculture", value: "Agriculture" },
  { label: "Legal Services", value: "Legal Services" },
  { label: "Government", value: "Government" },
  { label: "Automotive", value: "Automotive" },
  { label: "Hospitality", value: "Hospitality" },
  { label: "Construction", value: "Construction" },
  { label: "Aerospace & Defense", value: "Aerospace & Defense" },
  { label: "Pharmaceuticals", value: "Pharmaceuticals" },
  { label: "Non-Profit", value: "Non-Profit" },
  { label: "Others", value: "Others" },
];
